import React, { createContext, useContext, useState, useCallback } from 'react';
import ConfirmModal from '../components/Modals/ConfirmModal/ConfirmModal';

const ConfirmModalContext = createContext(null);

export function ConfirmModalProvider({ children }) {
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [onConfirmCallback, setOnConfirmCallback] = useState(null);

    // Modal'ı aç - çok basit
    const showConfirm = useCallback((onConfirm) => {
        setOnConfirmCallback(() => onConfirm);
        setIsOpen(true);
    }, []);

    // Onay verildi
    const handleConfirm = async () => {
        if (onConfirmCallback) {
            setLoading(true);
            try {
                await onConfirmCallback();
            } catch (error) {
                console.error('İşlem hatası:', error);
            } finally {
                setLoading(false);
                setIsOpen(false);
                setOnConfirmCallback(null);
            }
        }
    };

    // İptal edildi
    const handleCancel = () => {
        setIsOpen(false);
        setLoading(false);
        setOnConfirmCallback(null);
    };

    return (
        <ConfirmModalContext.Provider value={{ showConfirm }}>
            {children}
            
            <ConfirmModal
                isOpen={isOpen}
                onClose={handleCancel}
                onConfirm={handleConfirm}
                title="Kapatmak istediğinize emin misiniz?"
                message=""
                confirmText="Evet"
                cancelText="Hayır"
                variant="warning"
                icon=""
                loading={loading}
            />
        </ConfirmModalContext.Provider>
    );
}

export function useConfirmModal() {
    const context = useContext(ConfirmModalContext);
    
    if (!context) {
        throw new Error('useConfirmModal must be used within a ConfirmModalProvider');
    }
    
    return context;
}

export default ConfirmModalContext;